import React from 'react';
import PropTypes from 'prop-types';
import Menu from '../../../../../components/LazyWidgets/Menu';
import s from './skillsReflectionDropdown.module.css';

const SkillsReflectionDropdown = (props) => {
  const { dropDownObject, dropdownChangeHandler, activeDropdown } = props;
  const index = dropDownObject.findIndex(elem => elem.id === activeDropdown.id);
  const optSelected = index === -1
    ? dropDownObject[activeDropdown.id]
    : dropDownObject[index];

  return (
    <Menu
      id="skillsReflectionDropdown"
      className={s.menuContainer}
      options={dropDownObject}
      boxed
      hasLabel
      label="Draft:"
      selectedLabel={optSelected.name}
      onChange={dropdownChangeHandler}
    />
  );
};

SkillsReflectionDropdown.propTypes = {
  dropDownObject: PropTypes.array,
  dropdownChangeHandler: PropTypes.func,
  activeDropdown: PropTypes.object,
};

export default SkillsReflectionDropdown;
